// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mask_box[data-v-835e268a]{width:100%;height:100vh;display:flex;justify-content:center;align-items:center;position:absolute;background-color:#fff;z-index:99}", ""]);
// Exports
module.exports = exports;
